import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Form, Row, Container, Col, Card } from 'react-bootstrap';
import Select from 'react-select';
import { addMachine, getClients } from '../../services/services';
import SweetAlert from 'react-bootstrap-sweetalert';

let addMachineForm = {
	'client_id': '',
	'machine_name': ''
}

function AddMachines() {

	const [selectedClient, setSelectedClient] = useState();
	const [mstClients, setMstClients] = useState();
	const [values, setValues] = useState({
		machine_name: '',
		client_id: ''
	});
	const [showAlert, setShowAlert] = useState(false);
	

	useEffect(() => {
		getClients((response) => {
			// console.log(data)
			setMstClients(response.data)
		})
	}, [])

	const updateFormValues = (value, field) => {
		if(field === 'client_id'){
			setSelectedClient(value)
			value = value.value
		}

		addMachineForm[field] = value

		console.log("AddMachineForm = ", addMachineForm)
	}

	const addMachineSubmit = (e) => {
		e.preventDefault()
		// console.log(values)

		let reqBody = addMachineForm

		addMachine(reqBody, (response) => {
			console.log(response)

			setShowAlert(true)
		})
	}

	return (
		<Row>
			<Col>
				<Card>
					<Card.Header>
						<h4>Machine Details</h4>
					</Card.Header>
					<Card.Body>
						<Form onSubmit={addMachineSubmit}>
							<Row>
								<Col>
									<Form.Group>
										<Form.Label>Client</Form.Label>
										<Select
											value={selectedClient}
											options = {mstClients}
											onChange = {(value) => updateFormValues(value, 'client_id')}
											isSearchable = {false}
											isClearable
											placeholder='Select'
										/>
									</Form.Group>
								</Col>
								<Col>
									<Form.Group controlId="formMachineName">
										<Form.Label>Machine Name</Form.Label>
										<Form.Control type="text" placeholder="Enter Machine Name" onChange={(e) => updateFormValues(e.target.value, 'machine_name')}  />
									</Form.Group>
								</Col>
								
							</Row>
							<Row>
								<Col>
									<Button variant="primary" type="submit">
										Submit
									</Button>
								</Col>
							</Row>
						</Form>
					</Card.Body>
				</Card>
			</Col>

			{showAlert ?
				<SweetAlert 
					title="Success"
					onConfirm={()=>setShowAlert(false)}
				/>
				:
				<></>
			}
		</Row>
	);
};

export default AddMachines;